var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8337 16.625V15.0417C15.8337 14.2018 15.5 13.3964 14.9062 12.8025C14.3123 12.2086 13.5068 11.875 12.667 11.875H6.33366C5.49381 11.875 4.68835 12.2086 4.09449 12.8025C3.50062 13.3964 3.16699 14.2018 3.16699 15.0417V16.625",
    stroke: "#07575B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49967 8.70833C11.2486 8.70833 12.6663 7.29057 12.6663 5.54167C12.6663 3.79276 11.2486 2.375 9.49967 2.375C7.75077 2.375 6.33301 3.79276 6.33301 5.54167C6.33301 7.29057 7.75077 8.70833 9.49967 8.70833Z",
    stroke: "#07575B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.437c57b354bf4e92612ca7239eb5c626.svg";
export { ForwardRef as ReactComponent };